function setupBranching(radioName, sectionId, showValues) {
    const section = document.getElementById(sectionId);
    if (!section) return;

    const radios = Array.from(
        document.querySelectorAll(`input[type="radio"][name="${radioName}"]`)
    );
    if (!radios.length) return;

    const update = function() {
        const selected = radios.find(r => r.checked);
        section.style.display = selected && showValues.indexOf(selected.value) !== -1 ? '' : 'none';
    };

    radios.forEach(function(radio) {
        radio.addEventListener('change', update);
    });

    update();
}

exports.surveyAv = function(radioGroupName) {
    setupBranching(radioGroupName, 'why-more-than-once-section', ['2', '3-or-more']);
};

exports.surveyRtv = function() {
    setupBranching('tried-to-check', 'where-checked-section', ['yes']);
    setupBranching('how-confident', 'what-would-help-confidence-section', ['not-very-confident', 'not-confident-at-all']);
    setupBranching('how-many-times-submitted', 'why-more-than-once-section', ['2', '3-or-more']);
};
